/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "apiAuthSII",
            "endpoint": "https://grpzplq718.execute-api.us-east-1.amazonaws.com/qa",
            "region": "us-east-1"
        },
        {
            "name": "apiBoletaSII",
            "endpoint": "https://6xgmori395.execute-api.us-east-1.amazonaws.com/qa",
            "region": "us-east-1"
        },
        {
            "name": "apiConfiguracion",
            "endpoint": "https://sljshmc1m5.execute-api.us-east-1.amazonaws.com/qa",
            "region": "us-east-1"
        },
        {
            "name": "apiConfiguracionUsuario",
            "endpoint": "https://5a2cb7coz0.execute-api.us-east-1.amazonaws.com/qa",
            "region": "us-east-1"
        },
        {
            "name": "eBoletaActualizador",
            "endpoint": "https://eu3fz8em6a.execute-api.us-east-1.amazonaws.com/qa",
            "region": "us-east-1"
        },
        {
            "name": "notificaciones",
            "endpoint": "https://sm0s86hadh.execute-api.us-east-1.amazonaws.com/qa",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:337509f2-9c3b-4708-89a4-a1428535bce7",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_1GzLwtsLL",
    "aws_user_pools_web_client_id": "7s8m0q657u0jrfp28qaioaa94",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "boleta-sii-qa",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://dx8r8aidfc410.cloudfront.net"
};


export default awsmobile;
